import HttpService from "./htttp.service";

class BaseEntitiesService {
  getBaseEntities = async (query, cancelToken) => {
    const endpoint = "base-entities";
    return await HttpService.get(endpoint, query, cancelToken);
  };
}

export default new BaseEntitiesService();
